import { Grid } from '@frontierag/frontier-ui-library';
import { DataAccordionTitle, OrderStatus } from 'components';

import type { IOrderAccordionTitle } from './types';

export default function OrderAccordionTitle({
  directOrderId,
  internalOrderId,
  orderStatus,
  titlePrefix = '',
  transNamespace,
}: IOrderAccordionTitle) {
  return (
    <DataAccordionTitle text={titlePrefix} id={directOrderId || internalOrderId}>
      <Grid item xs={12} sm={5}>
        <OrderStatus
          transNamespace={transNamespace}
          status={orderStatus}
          containerStyle={{
            justifyContent: { xs: 'flex-start', sm: 'flex-end' },
          }}
        />
      </Grid>
    </DataAccordionTitle>
  );
}
